/**
 * WarningIconTriangle component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number | string} [props.size] - The size of the icon. Defaults to 16.
 * @param {string} [props.color] - The color of the icon. Defaults to "#FD0403".
 * @param {function} [props.onClick] - The action for when icon is clicked.
 * @param {string} [props.className] - The string for extra styling.
 * @returns {JSX.Element} The rendered WarningIcon component.
 */
const WarningIconTriangle = ({ size, color, onClick, className }) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={handleClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83406 2.50265C8.79613 0.835055 11.2029 0.835055 12.165 2.50265L18.2936 13.1256C19.2551 14.7922 18.0523 16.8749 16.1281 16.8749H3.87091C1.94677 16.8749 0.743912 14.7922 1.70545 13.1256L7.83406 2.50265ZM9.99969 6.87482C10.3449 6.87482 10.6247 7.15464 10.6247 7.49982V10.6248C10.6247 10.97 10.3449 11.2498 9.99969 11.2498C9.65452 11.2498 9.37469 10.97 9.37469 10.6248V7.49982C9.37469 7.15464 9.65452 6.87482 9.99969 6.87482ZM9.99969 13.7498C10.3449 13.7498 10.6247 13.47 10.6247 13.1248C10.6247 12.7796 10.3449 12.4998 9.99969 12.4998C9.65452 12.4998 9.37469 12.7796 9.37469 13.1248C9.37469 13.47 9.65452 13.7498 9.99969 13.7498Z"
        fill={color ?? "#865503"}
      />
    </svg>
  );
};

export default WarningIconTriangle;
